const StopIteration = {};
module.exports = StopIteration;
